module.exports = __webpack_public_path__ + "static/media/view4.3637889a.jpg";